import { render, staticRenderFns } from "./Mention.vue?vue&type=template&id=63349f4d&scoped=true&"
import script from "./Mention.vue?vue&type=script&lang=ts&"
export * from "./Mention.vue?vue&type=script&lang=ts&"
import style0 from "./Mention.vue?vue&type=style&index=0&id=63349f4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63349f4d",
  null
  
)

export default component.exports